<template>
    <div>
        <div class="flex center-xs space-top-1 space-bottom-2">
            <div class="vertical-center input-container">
                <div class="start-xs full-width" >
                    <label for="email">{{ step.label }}</label>
                    <input @keyup.enter="keycheck" v-model.trim="inputData" v-focus class="full-width data-hj-allow" type="email" :placeholder="step.placeholder" />
                    <div v-if="inputValid" class="valid-check"></div>
                </div>
                <div class="full-width">
                    <div v-if="displayErrorMessage" class="red-text space-top-2">
                        {{step.errorMessage}}
                    </div>
                </div>
             </div>
        </div>

        <ButtonSection
          :inputValid="inputValid"
          :order="order"
          :buttonText="step.buttonText"
          v-on:progress="verifyAndProgress()"
          v-on:back="$emit('back')"
        />
    </div>
</template>

<script>
import axios from 'axios';
import debounce from 'lodash.debounce';
import { email, minLength, required } from 'vuelidate/lib/validators';
import { INVALID_DOMAINS } from "../../corpweb_globals";

import ButtonSection from '../components/ButtonSection';

const invalidDomain = (value, vm)=>{
    if((vm.assetCount === "1 - 10" || vm.assetCount === "11 - 19") && vm.country === "Mexico" ){
        const domain = value.split("@")[1] || ""
        if(domain){
            return !INVALID_DOMAINS.includes(domain);
        }
        return true;
    }
    return true
}

export default {
    name: 'email',
    props: ['step', 'order'],
    components: {
        ButtonSection
    },
    directives: {
        focus: {
            inserted: function (el) {
                el.focus()
            }
        }
    },
    data() {
      return {
        dirty: false
      }
    },
    validations: {
        inputData: {
            required,
            minLength: minLength(2),
            email, 
            invalidDomain
        }
    },
    computed: {
        inputData: {
            get: function() {
                return this.$store.state.formFields[this.step.name];
            },
            set: debounce(function(value) {
                this.dirty = true;
                const name = this.step.name;
                this.$store.commit('updateField', { name, value })
            }, 600)
        },
        inputValid() {
            return !this.$v.inputData.$invalid;
        },
        displayErrorMessage() {
            return this.$v.inputData.$invalid && this.dirty;
        },
        country(){
            return this.$store.state.country
        },
        assetCount(){
            return this.$store.state.formFields.assetcount
        }
    },
    methods: {
        async verifyAndProgress() {
            this.verifyAndEnrich();
            this.$emit('progress', this.step.name);
        },
        async verifyAndEnrich() {
            await this.verifyEmail();
        },
        async verifyEmail() {
            try {
                this.$store.commit('emailValid', true);
                let response = await axios({
                    method: 'post',
                    url: '/validate',
                    headers: {
                        'Content-type': 'application/json'
                    },
                    data: {
                        inputToValidate: 'email',
                        email: this.$store.state.formFields[this.step.name]
                    }
                })
                if(response.status === 200) {
                    const emailValid = response.data.status === 'valid';
                    this.$store.commit('emailValid', emailValid);
                }
            } catch(e) {
                console.error("Email verification failed.");
            }
        },
        keycheck(e) {
            if (e.keyCode === 13 && this.inputValid) {
                this.$emit('progress');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
input[type=email] {
    border: 3px solid #0384FB;
    box-sizing: border-box;
}
</style>